"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpacingInsetSizeNano = exports.SpacingInsetSizeQuarck = exports.ShadowLevel4Mobile = exports.ShadowLevel4 = exports.ShadowLevel3Mobile = exports.ShadowLevel3 = exports.ShadowLevel2Mobile = exports.ShadowLevel2 = exports.ShadowLevel1Mobile = exports.ShadowLevel1 = exports.OpacityLevelSemitransparent = exports.OpacityLevelLight = exports.OpacityLevelMedium = exports.OpacityLevelIntense = exports.OpacityLevelSemiopaque = exports.LineHeightXxl = exports.LineHeightXl = exports.LineHeightLg = exports.LineHeightMd = exports.LineHeightSm = exports.LineHeightXs = exports.LineHeightDefault = exports.FontSizeGiant = exports.FontSizeDisplay = exports.FontSizeXxxl = exports.FontSizeXxl = exports.FontSizeXl = exports.FontSizeLg = exports.FontSizeMd = exports.FontSizeSm = exports.FontSizeXs = exports.FontSizeXxs = exports.FontSizeXxxs = exports.BreakpointContentXl = exports.BreakpointContentLg = exports.BreakpointContentMd = exports.BreakpointContentSm = exports.BreakpointContentXs = exports.BorderWidthBlack = exports.BorderWidthHeavy = exports.BorderWidthThick = exports.BorderWidthThin = exports.BorderWidthHairline = exports.BorderWidthNone = exports.BorderRadiusCircular = exports.BorderRadiusPill = exports.BorderRadiusLg = exports.BorderRadiusMd = exports.BorderRadiusSm = exports.BorderRadiusNone = void 0;
exports.SpacingSizeGiant = exports.SpacingSizeHuge = exports.SpacingSizeXxxl = exports.SpacingSizeXxl = exports.SpacingSizeXl = exports.SpacingSizeLg = exports.SpacingSizeMd = exports.SpacingSizeSm = exports.SpacingSizeXs = exports.SpacingSizeXxs = exports.SpacingSizeXxxs = exports.SpacingSizeNano = exports.SpacingSizeQuarck = exports.SpacingInsetSizeLg = exports.SpacingInsetSizeMd = exports.SpacingInsetSizeSm = exports.SpacingInsetSizeXs = void 0;
exports.BorderRadiusNone = "0px";
exports.BorderRadiusSm = "8px";
exports.BorderRadiusMd = "16px";
exports.BorderRadiusLg = "24px";
exports.BorderRadiusPill = "500px";
exports.BorderRadiusCircular = "50%";
exports.BorderWidthNone = "0px";
exports.BorderWidthHairline = "1px";
exports.BorderWidthThin = "2px";
exports.BorderWidthThick = "4px";
exports.BorderWidthHeavy = "8px";
exports.BorderWidthBlack = "16px";
exports.BreakpointContentXs = "0px";
exports.BreakpointContentSm = "0px";
exports.BreakpointContentMd = "768px";
exports.BreakpointContentLg = "1200px";
exports.BreakpointContentXl = "1500px";
exports.FontSizeXxxs = "12px";
exports.FontSizeXxs = "14px";
exports.FontSizeXs = "16px";
exports.FontSizeSm = "20px";
exports.FontSizeMd = "24px";
exports.FontSizeLg = "32px";
exports.FontSizeXl = "40px";
exports.FontSizeXxl = "48px";
exports.FontSizeXxxl = "64px";
exports.FontSizeDisplay = "80px";
exports.FontSizeGiant = "96px";
exports.LineHeightDefault = "100%";
exports.LineHeightXs = "115%";
exports.LineHeightSm = "120%";
exports.LineHeightMd = "133%";
exports.LineHeightLg = "150%";
exports.LineHeightXl = "170%";
exports.LineHeightXxl = "200%";
exports.OpacityLevelSemiopaque = 0.72;
exports.OpacityLevelIntense = 0.56;
exports.OpacityLevelMedium = 0.4;
exports.OpacityLevelLight = 0.16;
exports.OpacityLevelSemitransparent = 0.04;
exports.ShadowLevel1 = "0px 4px 8px";
exports.ShadowLevel1Mobile = {
    shadowColor: "#121212",
    shadowOffset: {
        width: 0,
        height: 4,
    },
    shadowOpacity: 0.16,
    shadowRadius: 2.62,
    elevation: 4
};
exports.ShadowLevel2 = "0px 8px 24px";
exports.ShadowLevel2Mobile = {
    shadowColor: "#121212",
    shadowOffset: {
        width: 0,
        height: 8,
    },
    shadowOpacity: 0.16,
    shadowRadius: 6.27,
    elevation: 10
};
exports.ShadowLevel3 = "0px 16px 32px";
exports.ShadowLevel3Mobile = {
    shadowColor: "#121212",
    shadowOffset: {
        width: 0,
        height: 16,
    },
    shadowOpacity: 0.16,
    shadowRadius: 11.95,
    elevation: 18
};
exports.ShadowLevel4 = "0px 16px 48px";
exports.ShadowLevel4Mobile = {
    shadowColor: "#121212",
    shadowOffset: {
        width: 0,
        height: 16,
    },
    shadowOpacity: 0.16,
    shadowRadius: 16,
    elevation: 24
};
exports.SpacingInsetSizeQuarck = "4px";
exports.SpacingInsetSizeNano = "8px";
exports.SpacingInsetSizeXs = "16px";
exports.SpacingInsetSizeSm = "24px";
exports.SpacingInsetSizeMd = "32px";
exports.SpacingInsetSizeLg = "40px";
exports.SpacingSizeQuarck = "4px";
exports.SpacingSizeNano = "8px";
exports.SpacingSizeXxxs = "16px";
exports.SpacingSizeXxs = "24px";
exports.SpacingSizeXs = "32px";
exports.SpacingSizeSm = "40px";
exports.SpacingSizeMd = "48px";
exports.SpacingSizeLg = "56px";
exports.SpacingSizeXl = "64px";
exports.SpacingSizeXxl = "80px";
exports.SpacingSizeXxxl = "120px";
exports.SpacingSizeHuge = "160px";
exports.SpacingSizeGiant = "200px";
